import React, { forwardRef, useImperativeHandle } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";

import { userPreferencesSelector, updateUserPreferences, userSelector } from "@kubera/common";

const RedDot = styled.div`
  position: absolute;
  top: 0.9375rem;
  right: 0.9375rem;
  border-radius: 50%;
  width: 0.5rem;
  height: 0.5rem;
  background: ${props => props.theme.gridRedColorForLightBackground};
`;

const RedDotComponent = ({ className = "", preference, childPreference, showIfUserBeforeThisTs }, ref) => {
  if (showIfUserBeforeThisTs == null) {
    console.error(
      `RedDot (preference "${preference}"): showIfUserBeforeThisTs is required. Pass the feature's *_RELEASE_TS from PortfolioActions to show the dot only to users who signed up before it shipped, or 0 to show it to every user.`
    );
  }

  const dispatch = useDispatch();

  const user = useSelector(userSelector);
  const userPreferences = useSelector(userPreferencesSelector);

  const userTsCreated = user?.tsCreated;
  const showRedDot =
    !(userPreferences[preference] && childPreference
      ? userPreferences[preference][childPreference]
      : userPreferences[preference]) &&
    (!showIfUserBeforeThisTs === true || (userTsCreated && userTsCreated * 1000 < showIfUserBeforeThisTs));

  useImperativeHandle(ref, () => ({
    isRedDotShown: () => {
      return !!showRedDot;
    },
    setPreferenceFlag: (bool = true) => {
      if (childPreference) {
        dispatch(updateUserPreferences({ [preference]: { ...userPreferences[preference], [childPreference]: bool } }));
      } else {
        dispatch(updateUserPreferences({ [preference]: bool }));
      }
    }
  }));

  if (showRedDot) {
    return <RedDot className={className} />;
  }
  return null;
};

export default forwardRef(RedDotComponent);
